import * as Yup from 'yup';

export function initialValues(market) {
    return {
        supportEmail: market?.supportEmail || "",
        market: market?.market ,
        address: market?.address ,
        enode: market?.enode ,
        network: market?.network ,
        membership: market?.membership ,
    };
}

export function validationSchema() {
    return Yup.object({
        supportEmail: Yup.string().required(true),
    });
}